import { type RepoFilterParams } from '@webapp/infrastructure/interfaces/repositories/RepoFilterParams'
import { orderDraftRepository } from '@webapp/modules/purchasing/data-access/repositories/OrderDraftRepository'
import { InitializeOrderDraftOrgCategoriesUseCase } from './InitializeOrderDraftOrgCategoriesUseCase'

export const initializeOrderDraftOrgCategoriesUseCase =
  new InitializeOrderDraftOrgCategoriesUseCase({
    getRequestablePrimaryCategory: (
      userId: number,
      params?: RepoFilterParams
    ) => orderDraftRepository.getRequestablePrimaryCategory(userId, params),
    getRequestableSecondaryCategories: (
      userId: number,
      primaryCategoryId: number,
      params?: RepoFilterParams
    ) =>
      orderDraftRepository.getRequestableSecondaryCategories(
        userId,
        primaryCategoryId,
        params
      ),
  }).execute
